export default {
  inject: ['load'],
  data() {
    return {
      flagShowForm: 6,
      DataPatientById: null,
      vitalSigns: [],
      accompanyingSymptoms: [],
      accompanyingSymptoms_Info: [],
      medicalHistory: [],
      drugHistory: [],
      allergyHistory: [],
      medicalExamination: null,
      bodyExamination: null,
      generalActions: {},
      technicianDrugs: [],
      medicalItems: [],
      patientResult: null,

      InitialAssessmentById: null,
      DetailByFollowup: null,

      showVitalSignsDialog: false,
      showAccompanyingSymptomsDialog: false,
      showMedicalHistoryDialog: false,
      showDrugHistoryDialog: false,
      showAllergyHistoryDialog: false,
      showMedicalExaminationDialog: false,
      showBodyExaminationDialog: false,
      showGeneralActionsDialog: false,
      showTechnicianDrugsDialog: false,
      showMedicalItemsDialog: false,
      showPatientResultDialog: false,
    };
  },
  methods: {
    getPatientByIdFunction_RFF: function (id) {
      this.dataGetPatientById = {};
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getPatientById', id).then(() => {
        if (this.$store.state.patientModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          let temp = this.$store.state.patientModule.patientSimpleData;
          this.DataPatientById = temp

        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.patientModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getPatientByIdFunction_RFF(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getPatientInitialAssessmentByIdFunction_RFF: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getPatientInitialAssessmentById', id).then(() => {
        if (this.$store.state.patientInitialAssessmentModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          let temp = this.$store.state.patientInitialAssessmentModule.patientInitialAssessment;
          this.InitialAssessmentById = temp

        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.patientInitialAssessmentModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.patientInitialAssessmentModule.successFlag) {
                this.getPatientInitialAssessmentByIdFunction_RFF(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getPatientDetailByFollowupFunction_RFF: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getPatientDetailByFollowup', id).then(() => {
        if (this.$store.state.patientDetailModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          let temp = this.$store.state.patientDetailModule.patientDetail;
          this.DetailByFollowup = temp

          if (temp.typeOfEmergency.title == 'ترومایی مرتبط با حمل و نقل') {
            this.flagShowForm = 1
          } else if (temp.typeOfEmergency.title == "ترومایی غیرمرتبط با حمل و نقل") {
            this.flagShowForm = 2
          } else if (temp.typeOfEmergency.title == 'بیماری') {
            if (temp.diagnosis == 'سکته مغزی') {
              this.flagShowForm = 3
            } else if (temp.diagnosis == 'مشکلات قلبی') {
              this.flagShowForm = 4
            } else if (temp.diagnosis == 'زایمان') {
              this.flagShowForm = 5
            } else { this.flagShowForm = 6 }
          }

        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.patientDetailModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.patientDetailModule.successFlag) {
                this.getPatientDetailByFollowupFunction_RFF(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getAllPatientVitalSignFunction_RFF: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllPatientVitalSign', id).then(() => {
        if (this.$store.state.patientVitalSignModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          let temp = this.$store.state.patientVitalSignModule.allPatientVitalSign;
          this.vitalSigns = temp

        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.patientVitalSignModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.patientVitalSignModule.successFlag) {
                this.getAllPatientVitalSignFunction_RFF(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError(this.$store.state.patientVitalSignModule.error);
          }
        }
      });
    },
    getAllPatientAccompanyingSymptomFunction_RFF: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllPatientAccompanyingSymptom', id).then(() => {
        if (this.$store.state.patientAccompanyingSymptomModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          let temp = this.$store.state.patientAccompanyingSymptomModule.allPatientAccompanyingSymptom;
          this.accompanyingSymptoms = temp
          this.handleDataPatientAccompanyingSymptoms_Info(temp)

        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.patientAccompanyingSymptomModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.patientAccompanyingSymptomModule.successFlag) {
                this.getAllPatientAccompanyingSymptomFunction_RFF(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError(this.$store.state.patientAccompanyingSymptomModule.error);
          }
        }
      });
    },
    getAllPatientMedicalHistoryFunction_RFF: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllPatientMedicalHistory', id).then(() => {
        if (this.$store.state.patientMedicalHistoryModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          let temp = this.$store.state.patientMedicalHistoryModule.allPatientMedicalHistory;
          this.medicalHistory = temp

        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.patientMedicalHistoryModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.patientMedicalHistoryModule.successFlag) {
                this.getAllPatientMedicalHistoryFunction_RFF(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError(this.$store.state.patientMedicalHistoryModule.error);
          }
        }
      });
    },
    getAllPatientDrugHistoryFunction_RFF: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllPatientDrugHistory', id).then(() => {
        if (this.$store.state.patientDrugHistoryModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          let temp = this.$store.state.patientDrugHistoryModule.allPatientDrugHistory;
          this.drugHistory = temp

        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.patientDrugHistoryModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.patientDrugHistoryModule.successFlag) {
                this.getAllPatientDrugHistoryFunction_RFF(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError(this.$store.state.patientDrugHistoryModule.error);
          }
        }
      });
    },
    getAllPatientAllergyHistoryFunction_RFF: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllPatientAllergyHistory', id).then(() => {
        if (this.$store.state.patientAllergyHistoryModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          let temp = this.$store.state.patientAllergyHistoryModule.allPatientAllergyHistory;
          this.allergyHistory = temp

        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.patientAllergyHistoryModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.patientAllergyHistoryModule.successFlag) {
                this.getAllPatientAllergyHistoryFunction_RFF(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError(this.$store.state.patientAllergyHistoryModule.error);
          }
        }
      });
    },
    getPatientMedicalExaminationByIdFunction_RFF: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getPatientMedicalExaminationById', id).then(() => {
        if (this.$store.state.patientMedicalExaminationModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          let temp = this.$store.state.patientMedicalExaminationModule.patientMedicalExamination;
          this.medicalExamination = temp

        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.patientMedicalExaminationModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.patientMedicalExaminationModule.successFlag) {
                this.getPatientMedicalExaminationByIdFunction_RFF(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError(this.$store.state.patientMedicalExaminationModule.error);
          }
        }
      });
    },
    getAllPatientBodyExaminationFunction_RFF: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllPatientBodyExamination', id).then(() => {
        if (this.$store.state.patientBodyExaminationModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          let temp = this.$store.state.patientBodyExaminationModule.allPatientBodyExamination;


          const result = {
            front: temp
              ?.filter(item => item?.isFront === true)
              ?.map(item => {
                const title = item?.bodyPart?.titleFront || '';
                const unitTitle = item?.typeOfInjury || '';
                return `${title} (${unitTitle})`;
              })
              ?.join(' ، ') || '',
            back: temp
              ?.filter(item => item?.isFront === false)
              ?.map(item => {
                const title = item?.bodyPart?.titleBack || '';
                const unitTitle = item?.typeOfInjury || '';
                return `${title} (${unitTitle})`;
              })
              ?.join(' ، ') || '',
          };
          this.bodyExamination = result

        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.patientBodyExaminationModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.patientBodyExaminationModule.successFlag) {
                this.getAllPatientBodyExaminationFunction_RFF(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError(this.$store.state.patientBodyExaminationModule.error);
          }
        }
      });
    },
    getAllPatientGeneralActionFunction_RFF: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllPatientGeneralAction', id).then(() => {
        if (this.$store.state.patientGeneralActionModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          let temp = this.$store.state.patientGeneralActionModule.allPatientGeneralAction;

          const result = temp?.reduce((acc, item) => {
            const title = item?.generalAction?.title || '';
            const category = item?.generalAction?.category || '';
            const isAfter = item?.isAfterTechnicianArrival;

            if (isAfter === true) {
              acc.after.push(title);
            } else {
              acc.before.push(title);
            }

            if (category) {
              if (!acc[category]) {
                acc[category] = { after: [], before: [] };
              }
              if (isAfter === true) {
                acc[category].after.push(title);
              } else {
                acc[category].before.push(title);
              }
            }

            return acc;
          }, { after: [], before: [] });

          const output = {};
          Object.keys(result).forEach(key => {
            if (key === 'after' || key === 'before') {
              output[key] = result[key].join(' ، ') || '';
            } else {
              output[key] = {
                after: result[key].after.join(' ، ') || '',
                before: result[key].before.join(' ، ') || '',
              };
            }
          });
          this.generalActions = output

        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.patientGeneralActionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.patientGeneralActionModule.successFlag) {
                this.getAllPatientGeneralActionFunction_RFF(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError(this.$store.state.patientGeneralActionModule.error);
          }
        }
      });
    },
    getAllPatientTechnicianDrugFunction_RFF: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllPatientTechnicianDrug', id).then(() => {
        if (this.$store.state.patientTechnicianDrugModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          let temp = this.$store.state.patientTechnicianDrugModule.allPatientTechnicianDrug;


          const result = temp?.map(item => {
            const drugTitle = item?.drug?.title || '';
            const unitTitle = item?.drug?.unit?.title || '';
            const orderTypeTitle = item?.drugOrderType?.title || '';
            const dosage = item?.dosage || '';

            return `(${drugTitle} ${unitTitle} ${orderTypeTitle} دوز ${dosage})`;
          }).join(' ، ');

          this.technicianDrugs = result

        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.patientTechnicianDrugModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.patientTechnicianDrugModule.successFlag) {
                this.getAllPatientTechnicianDrugFunction_RFF(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError(this.$store.state.patientTechnicianDrugModule.error);
          }
        }
      });
    },
    getAllPatientMedicalItemFunction_RFF: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllPatientMedicalItem', id).then(() => {
        if (this.$store.state.patientMedicalItemModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          let temp = this.$store.state.patientMedicalItemModule.allPatientMedicalItem;

          const result = temp?.map(item => {
            const medicalTitle = item?.medicalItem?.title || '';
            const count = item?.count || '';
            return `(${medicalTitle} تعداد ${count})`;
          }).join(' ، ');

          this.medicalItems = result

        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.patientMedicalItemModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.patientMedicalItemModule.successFlag) {
                this.getAllPatientMedicalItemFunction_RFF(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError(this.$store.state.patientMedicalItemModule.error);
          }
        }
      });
    },
    getPatientResultByIdFunction_RFF: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getPatientResultById', id).then(() => {
        if (this.$store.state.patientResultModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          let temp = this.$store.state.patientResultModule.patientResult;
          this.patientResult = temp

        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.patientResultModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.patientResultModule.successFlag) {
                this.getPatientResultByIdFunction_RFF(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError(this.$store.state.patientResultModule.error);
          }
        }
      });
    },

    handleDataPatientAccompanyingSymptoms_Info: function (data) {
      this.accompanyingSymptoms_Info = [];

      for (let i = 0; i < data.length; i++) {
        if (data[i].title == 'سردرد') {
          const id = this.accompanyingSymptoms_Info.length + 1;
          this.accompanyingSymptoms_Info.push({
            title: 'سردرد',
            info: [],
          });
          if (data[i].patientHeadacheDetail) {
            this.accompanyingSymptoms_Info[id - 1].info.push({
              title: data[i].patientHeadacheDetail.headacheType.title,
              content: 'نوع درد',
            });
            this.accompanyingSymptoms_Info[id - 1].info.push({
              title: data[i].patientHeadacheDetail.headacheLocation.title,
              content: 'محل درد',
            });
            this.accompanyingSymptoms_Info[id - 1].info.push({
              title: data[i].patientHeadacheDetail.headacheOtherSign.title,
              content: 'علائم همراه',
            });
          }
          if (data[i].patientHeadacheIllnessHistories.length > 0) {
            for (let j = 0; j < data[i].patientHeadacheIllnessHistories.length; j++) {
              this.accompanyingSymptoms_Info[id - 1].info.push({
                title: data[i].patientHeadacheIllnessHistories[j].headacheIllnessHistory.title,
                content: 'سابقه بیماری',
              });
            }
          }
          if (data[i].patientHeadacheOtherSpecificationDetails.length > 0) {
            for (let j = 0; j < data[i].patientHeadacheOtherSpecificationDetails.length; j++) {
              this.accompanyingSymptoms_Info[id - 1].info.push({
                title:
                  data[i].patientHeadacheOtherSpecificationDetails[j].headacheOtherSpecification
                    .title,
                content: 'سایر مشخصات',
              });
            }
          }
        } else if (data[i].title == 'BE FAST') {
          const id = this.accompanyingSymptoms_Info.length + 1;
          this.accompanyingSymptoms_Info.push({
            title: 'BE FAST',
            info: [],
          });
          if (data[i].patientBeFastDetail) {
            if (data[i].patientBeFastDetail.imbalance != null) {
              let text = 'خیر';
              if (data[i].patientBeFastDetail.imbalance == true) {
                text = 'بله';
              }
              this.accompanyingSymptoms_Info[id - 1].info.push({
                title: text,
                content: 'عدم تعادل',
              });
            }
            if (data[i].patientBeFastDetail.visionChanges != null) {
              let text = 'خیر';
              if (data[i].patientBeFastDetail.visionChanges == true) {
                text = 'بله';
              }
              this.accompanyingSymptoms_Info[id - 1].info.push({
                title: text,
                content: 'تغییرات بینایی',
              });
            }
            if (data[i].patientBeFastDetail.saggingFace != null) {
              let text = 'خیر';
              if (data[i].patientBeFastDetail.saggingFace == true) {
                text = 'بله';
              }
              this.accompanyingSymptoms_Info[id - 1].info.push({
                title: text,
                content: 'افتادگی صورت',
              });
            }
            if (data[i].patientBeFastDetail.paralysis != null) {
              let text = 'خیر';
              if (data[i].patientBeFastDetail.paralysis == true) {
                text = 'بله';
              }
              this.accompanyingSymptoms_Info[id - 1].info.push({
                title: text,
                content: 'ضعف یا فلج اندام ها',
              });
            }
            if (data[i].patientBeFastDetail.talkingProblem != null) {
              let text = 'خیر';
              if (data[i].patientBeFastDetail.talkingProblem == true) {
                text = 'بله';
              }
              this.accompanyingSymptoms_Info[id - 1].info.push({
                title: text,
                content: 'اشکال در صحبت کردن',
              });
            }
          }
        } else if (data[i].title == 'سرگیجه') {
          const id = this.accompanyingSymptoms_Info.length + 1;
          this.accompanyingSymptoms_Info.push({
            title: 'سرگیجه',
            info: [],
          });
          if (data[i].patientVertigoDetail) {
            this.accompanyingSymptoms_Info[id - 1].info.push({
              title: data[i].patientVertigoDetail.vertigoType.title,
              content: 'نوع سرگیجه',
            });
            this.accompanyingSymptoms_Info[id - 1].info.push({
              title: data[i].patientVertigoDetail.vertigoDuration.title,
              content: 'مدت سرگیجه',
            });
            this.accompanyingSymptoms_Info[id - 1].info.push({
              title: data[i].patientVertigoDetail.vertigoAggravatingFactor.title,
              content: 'عامل تشدید کننده',
            });
          }
          if (data[i].patientVertigoOtherSpecifications.length > 0) {
            for (let j = 0; j < data[i].patientVertigoOtherSpecifications.length; j++) {
              this.accompanyingSymptoms_Info[id - 1].info.push({
                title:
                  data[i].patientVertigoOtherSpecifications[j].vertigoOtherSpecification.title,
                content: 'سایر مشخصات',
              });
            }
          }
        } else if (data[i].title == 'درد قفسه سینه') {
          const id = this.accompanyingSymptoms_Info.length + 1;
          this.accompanyingSymptoms_Info.push({
            title: 'درد قفسه سینه',
            info: [],
          });
          if (data[i].patientChestPainDetail) {
            if (data[i].patientChestPainDetail) {
              if (data[i].patientChestPainDetail.isActivityPain != null) {
                let text = 'ندارد';
                if (data[i].patientChestPainDetail.isActivityPain == true) {
                  text = 'دارد';
                }
                this.accompanyingSymptoms_Info[id - 1].info.push({
                  title: text,
                  content: 'درد فعالیتی',
                });
              }
              this.accompanyingSymptoms_Info[id - 1].info.push({
                title: data[i].patientChestPainDetail.chestPainType.title,
                content: 'نوع درد',
              });
              this.accompanyingSymptoms_Info[id - 1].info.push({
                title: data[i].patientChestPainDetail.chestPainLocation.title,
                content: 'محل درد',
              });
              this.accompanyingSymptoms_Info[id - 1].info.push({
                title: data[i].patientChestPainDetail.chestPainPropagation.title,
                content: 'انتشار درد',
              });
              this.accompanyingSymptoms_Info[id - 1].info.push({
                title: data[i].patientChestPainDetail.chestPainDuration.title,
                content: 'مدت',
              });
              this.accompanyingSymptoms_Info[id - 1].info.push({
                title: data[i].patientChestPainDetail.painScale,
                content: 'نمره درد',
              });
            }
          }
        } else if (data[i].title == 'تنگی نفس') {
          const id = this.accompanyingSymptoms_Info.length + 1;
          this.accompanyingSymptoms_Info.push({
            title: 'تنگی نفس',
            info: [],
          });
          if (data[i].patientRespiratoryDetail) {
            if (data[i].patientRespiratoryDetail.hasActivityBreathProblem != null) {
              let text = 'ندارد';
              if (data[i].patientRespiratoryDetail.hasActivityBreathProblem == true) {
                text = 'دارد';
              }
              this.accompanyingSymptoms_Info[id - 1].info.push({
                title: text,
                content: 'تنگی نفس فعالیتی',
              });
            }
          }
        }
        // else {
        //   this.accompanyingSymptoms_Info.push({
        //     title: data[i].title,
        //     info: [],
        //   });
        // }
      }
    },
    showError: function (testError = '') {
      this.snackText = testError;
      if (this.$refs.snackRef) {
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
      } else {
        this.showErrorAlert(this.snackText);
      }
    },
  },
};
